import axios, { AxiosResponse } from 'axios'
import * as Sentry from '@sentry/vue'
import { Severity } from '@sentry/browser'
import store from '../store'

const sentryAxiosScope = new Sentry.Scope()
sentryAxiosScope.setLevel(Severity.Debug)

axios.interceptors.request.use((config) => {
  const token = store.state.idToken
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

axios.interceptors.response.use((res: AxiosResponse<any>) => {
  if (res.status >= 400 && res.status <= 599) {
    Sentry.captureMessage(`Received ${res.status} from API`, (scope) => {
      scope.setLevel(Severity.Debug)
      scope.setExtra('axiosResponseObject', res)
      return scope
    })
  }
  return res
}, (err: any) => {
  Sentry.captureException(err, sentryAxiosScope)
  return Promise.reject(err)
})
